import React from "react";
import {Copyright} from "../utils/fmapUtils";
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import myStyle from "./myStyle.css";
import { textAlign } from "@mui/system";

const useStyles = makeStyles((theme) => ({
      footer: {
        padding: theme.spacing(3, 2),
        marginTop: 'auto',
        // backgroundColor: '#90badd',
        //   color:"black",
          backgroundColor: "white",
          color: "black"
    },
}));

export default function Footer() {
    const classes = useStyles();
    return (
        <footer className={classes.footer}>
            <Container>
                <Copyright />
            </Container>
        </footer>
    );
}
